__turbopack_context__.v({
  "accessBody": "drilldown-module__ZI_FDa__accessBody",
  "accessHead": "drilldown-module__ZI_FDa__accessHead",
  "accessList": "drilldown-module__ZI_FDa__accessList",
  "accessName": "drilldown-module__ZI_FDa__accessName",
  "accessRole": "drilldown-module__ZI_FDa__accessRole",
  "accessRow": "drilldown-module__ZI_FDa__accessRow",
  "accessWhisper": "drilldown-module__ZI_FDa__accessWhisper",
  "accessWhy": "drilldown-module__ZI_FDa__accessWhy",
  "activity": "drilldown-module__ZI_FDa__activity",
  "addSub": "drilldown-module__ZI_FDa__addSub",
  "arrow": "drilldown-module__ZI_FDa__arrow",
  "askedNote": "drilldown-module__ZI_FDa__askedNote",
  "attention": "drilldown-module__ZI_FDa__attention",
  "attentionActs": "drilldown-module__ZI_FDa__attentionActs",
  "attentionAsks": "drilldown-module__ZI_FDa__attentionAsks",
  "attentionBtn": "drilldown-module__ZI_FDa__attentionBtn",
  "attentionDismiss": "drilldown-module__ZI_FDa__attentionDismiss",
  "attentionRow": "drilldown-module__ZI_FDa__attentionRow",
  "attentionText": "drilldown-module__ZI_FDa__attentionText",
  "body": "drilldown-module__ZI_FDa__body",
  "chipSlot": "drilldown-module__ZI_FDa__chipSlot",
  "doorDigest": "drilldown-module__ZI_FDa__doorDigest",
  "doorText": "drilldown-module__ZI_FDa__doorText",
  "factProvenance": "drilldown-module__ZI_FDa__factProvenance",
  "flowDistribution": "drilldown-module__ZI_FDa__flowDistribution",
  "flowDistributionLine": "drilldown-module__ZI_FDa__flowDistributionLine",
  "grid": "drilldown-module__ZI_FDa__grid",
  "headMeta": "drilldown-module__ZI_FDa__headMeta",
  "headerBar": "drilldown-module__ZI_FDa__headerBar",
  "inPlace": "drilldown-module__ZI_FDa__inPlace",
  "itemViewsGuest": "drilldown-module__ZI_FDa__itemViewsGuest",
  "itemViewsLink": "drilldown-module__ZI_FDa__itemViewsLink",
  "itemViewsOwn": "drilldown-module__ZI_FDa__itemViewsOwn",
  "itemViewsValue": "drilldown-module__ZI_FDa__itemViewsValue",
  "leaf": "drilldown-module__ZI_FDa__leaf",
  "lockGlyph": "drilldown-module__ZI_FDa__lockGlyph",
  "lockedSeat": "drilldown-module__ZI_FDa__lockedSeat",
  "loggedBy": "drilldown-module__ZI_FDa__loggedBy",
  "main": "drilldown-module__ZI_FDa__main",
  "markingFlow": "drilldown-module__ZI_FDa__markingFlow",
  "markingNote": "drilldown-module__ZI_FDa__markingNote",
  "markingWhen": "drilldown-module__ZI_FDa__markingWhen",
  "markingWho": "drilldown-module__ZI_FDa__markingWho",
  "markingWhy": "drilldown-module__ZI_FDa__markingWhy",
  "menuCost": "drilldown-module__ZI_FDa__menuCost",
  "menuState": "drilldown-module__ZI_FDa__menuState",
  "menuStateDot": "drilldown-module__ZI_FDa__menuStateDot",
  "metaGroup": "drilldown-module__ZI_FDa__metaGroup",
  "minimapSlot": "drilldown-module__ZI_FDa__minimapSlot",
  "needs": "drilldown-module__ZI_FDa__needs",
  "notFound": "drilldown-module__ZI_FDa__notFound",
  "ownHealth": "drilldown-module__ZI_FDa__ownHealth",
  "partyName": "drilldown-module__ZI_FDa__partyName",
  "phaseOutOfRole": "drilldown-module__ZI_FDa__phaseOutOfRole",
  "phoneDoors": "drilldown-module__ZI_FDa__phoneDoors",
  "pillFlow": "drilldown-module__ZI_FDa__pillFlow",
  "properties": "drilldown-module__ZI_FDa__properties",
  "propertiesCluster": "drilldown-module__ZI_FDa__propertiesCluster",
  "propertiesHead": "drilldown-module__ZI_FDa__propertiesHead",
  "propertyRow": "drilldown-module__ZI_FDa__propertyRow",
  "propertyTime": "drilldown-module__ZI_FDa__propertyTime",
  "proposeRow": "drilldown-module__ZI_FDa__proposeRow",
  "protectedNote": "drilldown-module__ZI_FDa__protectedNote",
  "railBlock": "drilldown-module__ZI_FDa__railBlock",
  "railFlowLine": "drilldown-module__ZI_FDa__railFlowLine",
  "railFlows": "drilldown-module__ZI_FDa__railFlows",
  "railOrientation": "drilldown-module__ZI_FDa__railOrientation",
  "relEmpty": "drilldown-module__ZI_FDa__relEmpty",
  "relGroup": "drilldown-module__ZI_FDa__relGroup",
  "relHead": "drilldown-module__ZI_FDa__relHead",
  "relKind": "drilldown-module__ZI_FDa__relKind",
  "relSubHead": "drilldown-module__ZI_FDa__relSubHead",
  "requestRow": "drilldown-module__ZI_FDa__requestRow",
  "row": "drilldown-module__ZI_FDa__row",
  "rowParties": "drilldown-module__ZI_FDa__rowParties",
  "rowStatus": "drilldown-module__ZI_FDa__rowStatus",
  "rowTitle": "drilldown-module__ZI_FDa__rowTitle",
  "rowUnassigned": "drilldown-module__ZI_FDa__rowUnassigned",
  "rows": "drilldown-module__ZI_FDa__rows",
  "seatLine": "drilldown-module__ZI_FDa__seatLine",
  "signalDot": "drilldown-module__ZI_FDa__signalDot",
  "statementNoteActions": "drilldown-module__ZI_FDa__statementNoteActions",
  "statementNoteError": "drilldown-module__ZI_FDa__statementNoteError",
  "statementNoteForm": "drilldown-module__ZI_FDa__statementNoteForm",
  "statementNoteLabel": "drilldown-module__ZI_FDa__statementNoteLabel",
  "statementValue": "drilldown-module__ZI_FDa__statementValue",
  "statementWord": "drilldown-module__ZI_FDa__statementWord",
  "statusLine": "drilldown-module__ZI_FDa__statusLine",
  "structure": "drilldown-module__ZI_FDa__structure",
  "subBlock": "drilldown-module__ZI_FDa__subBlock",
  "subDivider": "drilldown-module__ZI_FDa__subDivider",
  "suggestHead": "drilldown-module__ZI_FDa__suggestHead",
  "summary": "drilldown-module__ZI_FDa__summary",
  "summaryHead": "drilldown-module__ZI_FDa__summaryHead",
  "title": "drilldown-module__ZI_FDa__title",
  "titleDot": "drilldown-module__ZI_FDa__titleDot",
  "titleInput": "drilldown-module__ZI_FDa__titleInput",
  "titleText": "drilldown-module__ZI_FDa__titleText",
  "treeLabel": "drilldown-module__ZI_FDa__treeLabel",
  "unassigned": "drilldown-module__ZI_FDa__unassigned",
  "viewContext": "drilldown-module__ZI_FDa__viewContext",
  "viewContextGroup": "drilldown-module__ZI_FDa__viewContextGroup",
  "viewContextKey": "drilldown-module__ZI_FDa__viewContextKey",
  "viewContextLabel": "drilldown-module__ZI_FDa__viewContextLabel",
  "viewContextRow": "drilldown-module__ZI_FDa__viewContextRow",
  "viewContextRows": "drilldown-module__ZI_FDa__viewContextRows",
  "viewContextValue": "drilldown-module__ZI_FDa__viewContextValue",
});
